// extracted by extract-css-chunks-webpack-plugin
module.exports = {"product-badge":"TZK9m"};